<template lang="pug">
  header#the-header: .container: h1(v-text="h1")
</template>

<script>
export default {
  name: 'TheHeader',
  // Data ----------------------------------------------------------------------
  data () {
    return {
      h1: 'Получите портфель ценных бумаг за пару секунд'
    }
  }
}
</script>
